import { render, staticRenderFns } from "./BlockUI.vue?vue&type=template&id=afe6e586&scoped=true&"
import script from "./BlockUI.vue?vue&type=script&lang=js&"
export * from "./BlockUI.vue?vue&type=script&lang=js&"
import style0 from "./BlockUI.vue?vue&type=style&index=0&id=afe6e586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe6e586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
